<template>
    <div class="product-menu">
        <div class="product-menu-inner">
            <button type="button" @click="closeProductMenu" class="product-close">
                <i class="fa fa-times" aria-hidden="true"></i>
            </button>
            <div class="res-row row bg-white p-5">

                <div class="col-lg-6 d-flex flex-column justify-content-center py-5">
                        <h4 class="boldest upper oswald deep-blue pt-2 pb-3">{{group.category}}</h4>
                        <h2 class="michroma deep-blue dpd-prod-title" v-html="$root.superScript(group.name)"></h2>
                <div class="dark-gray py-3">{{group.copy}}</div> 
                       <div class="py-2 red-button"><a class="elementor-button" :href="(`${group.link}`)"> Browse {{group.name}}</a>
                        </div> 
                </div>
                <div class="col-lg-6 d-flex flex-column justify-content-center py-5">
                         <img :src="(`${group.image}`)" >
                </div>
        </div>

        <div class="resources d-flex flex-row align-items-center justify-content-center"> 
            <div class="row w-100 res-row">
                <div class="col-6">
                    <div class="row res-grid"> 
                        <div class="col-md-4 grid-item pdf-img d-flex align-items-center justify-content-center">
                            <img :src="(`${group.res1image}`)" >
                        </div>
                            <div class="col-md-8 d-flex justify-content-center flex-column grid-item">
                                <div class="medium-gray w-100 pb-3 pr-5"> {{group.res1name}} </div> 
                                <a class="deep-blue upper h6" :href="(`${group.res1link}`)" target="_blank" rel="noopener noreferrer">Read More</a>
                            </div>
                    </div>
                </div> 
            
                <div class="col-6">
                    <div class="row res-grid"> 
                        <div class="col-md-4 grid-item pdf-img d-flex align-items-center justify-content-center">
                            <img :src="(`${group.res2image}`)" >
                        </div>
                        <div class="col-md-8 d-flex justify-content-center flex-column grid-item">
                            <div class="medium-gray w-100 pb-3 pr-5">{{group.res2name}}</div><a class="deep-blue upper h6" :href="(`${group.res2link}`)" target="_blank" rel="noopener noreferrer">Read More</a>
                        </div>
                    </div>
                </div>

                <div class="col-6" v-if="typeof group.res3name !== 'undefined'">
                    <div class="row res-grid"> 
                        <div class="col-md-4 grid-item pdf-img d-flex align-items-center justify-content-center">
                            <img :src="(`${group.res3image}`)" >
                        </div>
                        <div class="col-md-8 d-flex justify-content-center flex-column grid-item">
                            <div class="medium-gray w-100 pb-3 pr-5">{{group.res3name}}</div><a class="deep-blue upper h6" :href="(`${group.res3link}`)" target="_blank" rel="noopener noreferrer">Read More</a>
                        </div>
                    </div>
                </div>
                </div> 
            </div>
        </div>
    </div>
</template>
<script>
    import _ from 'lodash';
    import 'slick-carousel';
    import Products from '../data-src/Products.json';
    import $ from 'jquery';
window.$ = require('jquery');

    export default {
        props : ["group"],
        components : {
            
        },
        created() {
            this.products = _.filter(Products, (product) => {
                return _.findIndex(this.group.products, function(o) {
                    return o == product.handle;
                }) > -1;
            });
        },
        data() {
            return {
                maxPerSlide : 5,
                products: []
            }
        },
        computed : {
            rows() {
                return this.products.length > this.maxPerSlide ? 2 : 1;
            },
            slidesPerRow() {
                return this.products.length > this.maxPerSlide ? 3 : 1;
            }
        },
        mounted() {
            if( this.products.length > this.maxPerSlide ) {
                $(this.$el).find('.slides').slick({
                    infinite: false,
                    rows: this.rows,
                    slidesPerRow: this.slidesPerRow,
                    responsive : [
                        {
                            breakpoint : 992,
                            settings : {
                                infinite: false,
                                rows : 1,
                                slidesPerRow : 1,
                                slidesToShow : 1,
                                slidesToScroll : 1
                            }
                        }
                    ]
                });

            } else {
                $(this.$el).find('.slides').addClass('no-slick');

                if( this.products.length == 1 ) {
                    if( this.group.menu_type == 'product-video' ) {
                        $(this.$el).find('.slides .product-item').addClass('col-md-10');
                    } else {
                        $(this.$el).find('.slides .product-item').addClass('col-md-6');
                    }
                } else if(this.products.length % 2 != 0 ) {
                    $(this.$el).find('.slides .product-item').addClass('col-md-4');
                } else {
                    $(this.$el).find('.slides .product-item').addClass('col-md-6');
                }
            }
        },
        methods : {
            closeProductMenu() {
                this.$emit('close-product-menu');
            },
            closeSubMenu() {
                this.$emit('close-sub-menu');
            }
        }
    }
</script>